import { render, staticRenderFns } from "./SysLanguageList.vue?vue&type=template&id=3a51b412&scoped=true&"
import script from "./SysLanguageList.vue?vue&type=script&lang=js&"
export * from "./SysLanguageList.vue?vue&type=script&lang=js&"
import style0 from "./SysLanguageList.vue?vue&type=style&index=0&id=3a51b412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51b412",
  null
  
)

export default component.exports